import ConstantApi from '../../../../ConstantApi.js';
import axiosCall from '../../../axiosCall.js';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions.js';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions.js';
import { fetchSizeInfoData } from '../../../sizeInfo/sizeInfo.actions.js';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions.js';
import { fetchYarnPOProgramDropdown, fetchYarnPOSalesOrderDropdown, fetchYarnPOSupplierDropdown } from '../../YarnPO/yarnPO/yarnPO.actions.js';
import {
    FETCH_IRONING_PACKING_DC_REQUEST,
    CREATE_IRONING_PACKING_DC_REQUEST,
    CREATE_IRONING_PACKING_DC_SUCCESS,
    CREATE_USER_FORM_IRONING_PACKING_DC,
    DELETE_IRONING_PACKING_DC_FAILURE,
    DELETE_IRONING_PACKING_DC_REQUEST,
    DELETE_IRONING_PACKING_DC_SUCCESS,
    FETCH_SINGLE_IRONING_PACKING_DC_FAILURE,
    FETCH_SINGLE_IRONING_PACKING_DC_REQUEST,
    FETCH_SINGLE_IRONING_PACKING_DC_SUCCESS,
    FETCH_IRONING_PACKING_DC_FAILURE,
    FETCH_IRONING_PACKING_DC_SUCCESS,
    IRONING_PACKING_DC_USERFORM_RESET,
    UPDATE_IRONING_PACKING_DC_FAILURE,
    UPDATE_IRONING_PACKING_DC_REQUEST,
    UPDATE_IRONING_PACKING_DC_SUCCESS,
    IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_IRONING_PACKING_DC_STYLE_REQUEST,
    FETCH_IRONING_PACKING_DC_STYLE_SUCCESS,
    FETCH_IRONING_PACKING_DC_STYLE_FAILURE,
    FETCH_IRONING_PACKING_DC_INVOICE_REQUEST,
    FETCH_IRONING_PACKING_DC_INVOICE_SUCCESS,
    FETCH_IRONING_PACKING_DC_INVOICE_FAILURE,
    CREATE_IRONING_PACKING_DC_FAILURE,
    CLOSE_BTN_POST_REQUEST_SUCCESS,
    CLOSE_BTN_POST_REQUEST_FAILURE,
    CLOSE_BTN_POST_REQUEST_REQUEST
} from './ironingPackingDC.actionsType.js';
// import {
//     CREATE_IRONING_PACKING_DC_FAILURE,
//     CREATE_IRONING_PACKING_DC_REQUEST,
//     CREATE_IRONING_PACKING_DC_SUCCESS,
//     CREATE_USER_FORM_IRONING_PACKING_DC,
//     DELETE_IRONING_PACKING_DC_FAILURE,
//     DELETE_IRONING_PACKING_DC_REQUEST,
//     DELETE_IRONING_PACKING_DC_SUCCESS,
//     FETCH_SINGLE_IRONING_PACKING_DC_FAILURE,
//     FETCH_SINGLE_IRONING_PACKING_DC_REQUEST,
//     FETCH_SINGLE_IRONING_PACKING_DC_SUCCESS,
//     FETCH_IRONING_PACKING_DC_FAILURE,
//     FETCH_IRONING_PACKING_DC_REQUEST,
//     FETCH_IRONING_PACKING_DC_SUCCESS,
//     IRONING_PACKING_DC_USERFORM_RESET,
//     UPDATE_IRONING_PACKING_DC_FAILURE,
//     UPDATE_IRONING_PACKING_DC_REQUEST,
//     UPDATE_IRONING_PACKING_DC_SUCCESS,
//     IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
//     FETCH_IRONING_PACKING_DC_STYLE_REQUEST,
//     FETCH_IRONING_PACKING_DC_STYLE_SUCCESS,
//     FETCH_IRONING_PACKING_DC_STYLE_FAILURE,
//     FETCH_IRONING_PACKING_DC_INVOICE_REQUEST,
//     FETCH_IRONING_PACKING_DC_INVOICE_SUCCESS,
//     FETCH_IRONING_PACKING_DC_INVOICE_FAILURE
// } from './ironingPackingDC.actionsType';

// FETCH PROPERTY MASTER
export let fetchIroningPackingDC = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.ironingAndPackingDCMasterGET}?FldFromDate=${startDate}&FldToDate=${endDate}&FldFKUnitId=${-1}`,

        responseTypeRequest: FETCH_IRONING_PACKING_DC_REQUEST,
        responseTypeSuccess: FETCH_IRONING_PACKING_DC_SUCCESS,
        responseTypeFailure: FETCH_IRONING_PACKING_DC_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createIroningPackingDCUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_IRONING_PACKING_DC, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createIroningPackingDCMaster = (formData, modalClose, startDate, endDate, unitId, isDetail) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        ...formData,
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldDCNo: 'Auto Generated',
        fldDCDate: today.toISOString(),
        fldDeliveryStartDate: formData?.fldDeliveryStartDate ? formData.fldDeliveryStartDate : today.toISOString(),
        fldDeliveryEndDate: formData?.fldDeliveryEndDate ? formData.fldDeliveryEndDate : today.toISOString(),
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        fldNoofBags: Number(formData.fldNoofBags),
        fldTotalQty: Number(formData.fldTotalQty),
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,
        fldPreparedBy: 'dummy',
        fldPrepareDate: today.toISOString(),
        fldVerifyBy: 'dummy',
        fldVerifyDate: today.toISOString(),
        fldAuthorizeBy: 'dummy',
        fldAuthorizeDate: today.toISOString(),
        fldInwardBy: 'dummy',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: 'dummy',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms)
        // fldFKSizeInfo: parseInt(formData.fldFKSizeInfo)
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.ironingAndPackingDCMasterPOST}`,
        responseTypeRequest: CREATE_IRONING_PACKING_DC_REQUEST,
        responseTypeSuccess: CREATE_IRONING_PACKING_DC_SUCCESS,
        responseTypeFailure: CREATE_IRONING_PACKING_DC_FAILURE,
        resetFormData: isDetail ? IRONING_PACKING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB : IRONING_PACKING_DC_USERFORM_RESET,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchIroningPackingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleIroningPackingDCMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.ironingAndPackingDCMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_IRONING_PACKING_DC_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_IRONING_PACKING_DC_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_IRONING_PACKING_DC_FAILURE,
        singlApiArray: [
            fetchSeasonMaster(),
            fetchYarnPOSupplierDropdown('TblIroningAndPackingDC'),
            fetchCommonPropertyById(52),
            fetchCommonPropertyById(46),
            fetchCommonPropertyById(28),
            fetchUnitMaster(),
            fetchYarnPOProgramDropdown('TblIroningAndPackingDC'),
            fetchYarnPOSalesOrderDropdown(),
            // fetchStyleMasterBasicData(),
            fetchSizeInfoData()
            // fetchIroningPackingDCStyleGetList()
        ]
    };
    return axiosCall(config);
};

export let getIroningPackingDCInvoiceDataV2 = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.ironingPackingDCInvoiceGET}/${id}`,
        responseTypeRequest: FETCH_IRONING_PACKING_DC_INVOICE_REQUEST,
        responseTypeSuccess: FETCH_IRONING_PACKING_DC_INVOICE_SUCCESS,
        responseTypeFailure: FETCH_IRONING_PACKING_DC_INVOICE_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateIroningPackingDCMaster = (formData, id, startDate, endDate, unitId) => {
    // console.log('formData', formData)
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(formData.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: parseInt(formData.fldFKDepartment),
        fldFKSizeInfo: 0,
        fldDCNo: formData?.fldDCNo,
        fldDCDate: formData?.fldDCDate,
        fldFKStyle: formData.fldFKStyle,
        fldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(formData.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(formData.fldFKDeliveryAt),
        fldNoofBags: Number(formData.fldNoofBags),
        fldTotalQty: Number(formData.fldTotalQty),
        fldInwardQty: formData?.fldInwardQty,
        fldCancelQty: formData?.fldCancelQty,
        fldBalanceQty: formData?.fldBalanceQty,
        fldIsInHouseProduction: formData?.fldIsInHouseProduction,
        fldReason: formData.fldReason || '',
        fldIsPrepared: formData.fldIsPrepared,
        fldPreparedOn: formData.fldPreparedOn || new Date(),
        fldIsVerified: formData.fldIsVerified,
        fldVerifiedBy: formData.fldVerifiedBy || 'String',
        fldVerifiedOn: formData.fldVerifiedOn || new Date(),
        fldIsAuthorized: formData.fldIsAuthorized,
        fldAuthorizedBy: formData.fldAuthorizedBy || 'String',
        fldAuthorizedOn: formData.fldAuthorizedOn || new Date(),

        fldAuthorizeBy: formData.fldAuthorizeBy || '',
        fldAuthorizeDate: formData.fldAuthorizeDate || today.toISOString(),

        fldInwardBy: 'dummy',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldModifiedBy: 11,
        fldModifiedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,

        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: 'dummy',
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.ironingAndPackingDCMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_IRONING_PACKING_DC_REQUEST,
        responseTypeSuccess: UPDATE_IRONING_PACKING_DC_SUCCESS,
        responseTypeFailure: UPDATE_IRONING_PACKING_DC_FAILURE,
        resetFormData: IRONING_PACKING_DC_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchIroningPackingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteIroningPackingDCMaster = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.ironingAndPackingDCMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_IRONING_PACKING_DC_REQUEST,
        responseTypeSuccess: DELETE_IRONING_PACKING_DC_SUCCESS,
        responseTypeFailure: DELETE_IRONING_PACKING_DC_FAILURE,
        modalClose: true,
        getAllData: fetchIroningPackingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

export let fetchIroningPackingDCStyleGetList = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.ironingPackingDCDKStyleMasterGET}?ActionCode=PRD`,
        responseTypeRequest: FETCH_IRONING_PACKING_DC_STYLE_REQUEST,
        responseTypeSuccess: FETCH_IRONING_PACKING_DC_STYLE_SUCCESS,
        responseTypeFailure: FETCH_IRONING_PACKING_DC_STYLE_FAILURE
    };
    return axiosCall(config);
};
export let PostCloseIconApiIroningPacking = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.updateAllCloseIconIroning}?FldId=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CLOSE_BTN_POST_REQUEST_REQUEST,
        responseTypeSuccess: CLOSE_BTN_POST_REQUEST_SUCCESS,
        responseTypeFailure: CLOSE_BTN_POST_REQUEST_FAILURE,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};
